import React from 'react';
import { motion } from 'framer-motion';

export default function Settings() {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="h-full flex flex-col pb-20 sm:pb-0 overflow-y-auto pr-2"
    >
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Studio Configurations</h1>
        <p className="text-[#94A3B8] text-sm mt-1">System preferences and integrations</p>
      </div>

      <div className="max-w-2xl space-y-6">
        <div className="glass-panel p-6">
          <h2 className="text-lg font-semibold text-white mb-4 border-b border-white/10 pb-2">Interface</h2>
          
          <div className="flex items-center justify-between py-3">
            <div>
              <div className="text-white font-medium">Holographic Overlays</div>
              <div className="text-sm text-[#94A3B8]">Enable 3D visual effects on charts</div>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" defaultChecked />
              <div className="w-11 h-6 bg-black/50 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#9D4EDD] border border-white/10"></div>
            </label>
          </div>

          <div className="flex items-center justify-between py-3">
            <div>
              <div className="text-white font-medium">Auto-Sync Comm-Links</div>
              <div className="text-sm text-[#94A3B8]">Keep vendor channels active in background</div>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" />
              <div className="w-11 h-6 bg-black/50 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#9D4EDD] border border-white/10"></div>
            </label>
          </div>
        </div>

        <div className="glass-panel p-6">
          <h2 className="text-lg font-semibold text-white mb-4 border-b border-white/10 pb-2">Security & Access</h2>
          
          <div className="space-y-4">
            <div className="bg-black/30 p-4 rounded-lg border border-white/5 flex justify-between items-center">
              <div>
                <div className="text-sm text-[#94A3B8] uppercase tracking-wider mb-1">Current Protocol</div>
                <div className="text-white font-mono">EN-SEC-ALPHA</div>
              </div>
              <button className="text-sm text-[#9D4EDD] hover:text-white transition-colors">Rotate Keys</button>
            </div>
            <p className="text-xs text-[#94A3B8]">Warning: Rotating keys will disconnect all currently active remote terminals.</p>
          </div>
        </div>

        {/* Footer Credit - Mandatory */}
        <div className="mt-12 text-center pb-8">
          <p className="text-sm text-[#94A3B8] font-light tracking-wide">
            Made by LingLink AI and <span className="text-[#E5C158]">DigLab AI</span>
          </p>
        </div>
      </div>
    </motion.div>
  );
}